/** Read-only helpers over a received view. No game logic: lookups and formatting only. */
import { useGame } from "./store.ts";
import type { PlayerView, PublicView, RosterEntry } from "./types.ts";

export function playerOf(view: PlayerView | PublicView, id: string | null | undefined) {
  if (!id) return undefined;
  const pub = view.kind === "player" ? view.public : view;
  return pub.roster.find((p) => p.id === id);
}

export function nameOf(view: PlayerView | PublicView, id: string | null | undefined): string {
  return playerOf(view, id)?.name ?? "Someone";
}

/** The current view; only call inside the game shell, which renders once a view exists. */
export function useView(): PlayerView {
  const view = useGame((s) => s.view);
  if (!view) throw new Error("useView: no view yet");
  return view;
}

export function living(roster: readonly RosterEntry[]): RosterEntry[] {
  return roster.filter((p) => p.alive && !p.removed);
}

export const COUNCIL_PHASES = new Set([
  "discussion",
  "nominations",
  "defence",
  "ballot",
  "replacement",
]);
